/* eslint-disable @typescript-eslint/no-explicit-any */
/**
 * @desc 已登录绑定微信第三方账户
 */
import { defaultSuccess, defaultError, http } from "@/plugins/axios";

export default async function (
  wxUserReq: member.WxUserReq,

  success: ({
    data,
    ext,
    state,
    errors,
  }: {
    data: boolean;
    ext: ObjectMap;
    state: "SUCCESS" | "FAIL" | "EXCEPTION";
    errors?: Array<string>;
  }) => void = defaultSuccess,
  fail: (error: string) => void = defaultError
): Promise<void> {
  return http({
    method: "post",
    url: `/member/wx-user/binding`,
    data: wxUserReq,
  })
    .then((data) => success(data as any))
    .catch((error) => fail(error));
}
